export const GET_USERS_REQUEST = 'GET_REASSIGN_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_REASSIGN_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_REASSIGN_USERS_FAILED';

export const SET_SELECTED_USER = 'SET_REASSIGN_SELECTED_USER';
